<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container style="max-width: 1240px" class="py-0">
                    <v-layout row wrap pt-5 pb-5 v-if="showProductsTab">
                        <v-tabs
                                v-model="product"
                                :grow="true"
                                slider-color="#000"
                        >
                            <v-tab @click="goToNew" style="min-width: 160px">
                                Новый полис
                            </v-tab>
                            <v-tab @click="" style="min-width: 160px">
                                Пролонгация
                            </v-tab>
                        </v-tabs>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 pt-3 pb-3>
                            <h2>Продлеваемый полис</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 sm6 md4 pt-0>
                            <v-select
                                v-model="company"
                                label="Страховая компания"
                                :items="[
                                    { name: 'АльфаСтрахование', val: 'alpha' },
                                    { name: 'Ренессанс Страхование', val: 'renessans' },
                                    // { name: 'Ингосстрах', val: 'ingosstrah' },
                                    // { name: 'СОГАЗ', val: 'sogaz' },
                                ]"
                                :rules="[rules.required]"
                                item-value='val'
                                item-text='name'
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 md4 pt-0>
                            <v-text-field
                                    v-model="prevPolicyNumber"
                                    label="Серия и номер полиса"
                                    :rules="[rules.required, rules.policyNumber]"
                                    mask="SSS ##########"
                                    return-masked-value
                                    validation-on-blur
                            />
                        </v-flex>

                        <v-flex xs12 sm6 md4 pt-4>
                            <p style="font-size: 14px">Имейте в виду, что полис будет пролонгирован с теми же данными, что в прошлом году.</p>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex pb-3 pt-3>
                            <h2>Страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="insurer.fio.surname"
                                label="Фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="insurer.fio.name"
                                label="Имя"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="insurer.fio.patronymic"
                                label="Отчество"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg2 py-0>
                            <osago-date
                                v-model="insurer.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateToday"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1240px" pt-0>
                    <osago-user v-model="user"/>

                    <v-layout pt-4 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="validate"
                                   :disabled="Boolean(processings)"
                                   class="submit-button block">
                                Рассчитать окончательную стоимость
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>

        <transition name="fade">
            <v-container bg fill-height grid-list-md text-xs-center
                         style="width: 100%"
                         v-show="preloading"
                         class="preloading"
            >
                <v-layout row wrap align-center>
                    <v-flex>
                        <div class="preloader-circle"></div>
                        <h2>Загрузка</h2>
                        <br>
                        Обычно это занимает не больше 30 секунд.<br>
                        Ждем ответы от страховых компаний.
                    </v-flex>
                </v-layout>
            </v-container>
        </transition>

        <companies-list :companiesList="companiesList"/>

        <transition name="fade">
            <osago-preview
                v-if="preview.show"
                :preparedFormData="preparedFormData"
                :return="this.returnToEdit"
                :submit="this.submit"
                :loading="this.preloading"
            />
        </transition>

    </v-app>
</template>

<script>
    import _ from 'lodash';
    import ymMixin from '../mixins/ym';

    export default {
        props: ['params', 'authUser'],
        mixins: [ymMixin],

        data: () => ({
            // FormData
            company: 'alpha',
            prevPolicyNumber: null,
            privacyPolicyApproved: false,
            insurer: {
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false
                },
                birthday: null
            },
            user: {
                phone: '7',
                email: null
            },
            // FormData end

            uuid: null,
            valid: true,
            product: 1,
            showProductsTab: true,

            dateToday: '',
            dateTomorrow: '',
            dateFrom: '',
            dateStart: '',
            getpolisPhone: '',

            preloading: false,
            preview: {
                show: false,
            },
            processings: 0,
            companiesList: [],

            lastSavedFormData: null,
            preparedFormData: null,
            autoSaveInterval: null,

            rules: {
                required: v => !!v || 'Обязательное поле',
                policyNumber: v => /^[А-ЯA-Z]{3} \d{10}$/.test(v) || 'Неверный формат',
                approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных',
            },
        }),

        created: function () {
            const params = JSON.parse(window.atob(this.params));

            this.uuid = params.uuid;
            this.loadConfig(params.config);
            if (params.orderData) {
                this.loadOrderData(params.orderData);
                this.showProductsTab = false;
            }
            if (!params.orderData) {
                if (this.authUser && (this.authUser.email || this.authUser.phone)) {
                    this.user.email = this.authUser.email ? this.authUser.email : '';
                    this.user.phone = this.authUser.phone ? this.authUser.phone.replace(/\D/g, '') : '';
                }
            }
            if (params.companiesList) {
                this.companiesList = params.companiesList;
            }

            this.autoSaveOn(5000);
        },

        updated: function () {
            window.tippy.default('.tip-icon');
        },

        computed: {
        },

        methods: {
            loadConfig(config) {
                this.getpolisPhone = config.getpolis_phone;
                this.dateToday = config.todayDate;
                this.dateTomorrow = config.tomorrowDate;
                this.dateFrom = this.dateStart = config.offsetDate;
            },

            loadOrderData(data) {
                this.company = data.company;
                this.prevPolicyNumber = data.prevPolicyNumber;
                if (data.insurer.fio.noPatronymic === undefined) {
                    data.insurer.fio.noPatronymic = false;
                }
                this.insurer = Object.assign(this.insurer, data.insurer);
                this.user = Object.assign(this.user, data.user);
                if (!data.user.email) {
                    this.user.email = this.authUser.email ? this.authUser.email : '';
                }
                if (!data.user.phone) {
                    this.user.phone = this.authUser.phone ? this.authUser.phone.replace(/\D/g, '') : '';
                }
                this.privacyPolicyApproved = data.privacyPolicyApproved === true;
            },

            prepareFormData() {
                this.preparedFormData = {
                    company: _.cloneDeep(this.company),
                    prevPolicyNumber: _.cloneDeep(this.prevPolicyNumber),
                    privacyPolicyApproved: this.privacyPolicyApproved,
                    insurer: _.cloneDeep(this.insurer),
                    transport: _.cloneDeep(this.transport),
                    user: _.cloneDeep(this.user)
                };
            },

            autoSaveOn(timeout) {
                let that = this;

                this.autoSaveInterval = setInterval(function () {
                    that.prepareFormData();

                    if (that.lastSavedFormData == null) {
                        that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                        return;
                    }

                    if (!_.isEqual(that.lastSavedFormData, that.preparedFormData)) {
                        that.save(that.preparedFormData);
                        that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                    }
                }, timeout);
            },

            autoSaveOff() {
                clearInterval(this.autoSaveInterval);
            },

            save(formData) {
                axios.post('/osago/prolongation' + (this.uuid ? '/' + this.uuid + '/save' : '/save'), formData)
                    .then(response => {
                        if (response.data.uuid) {
                            this.uuid = response.data.uuid;
                            window.history.pushState(null, null, '/osago/prolongation/' + this.uuid);
                        }

                    }).catch(error => {
                    console.log(error);
                    //throw error;
                    if (error.response.data.message) {
                        // PNotify.alert('Ошибка. Проверьте правильность введенных данных.');
                        /*                            PNotify.alert(error.response.data.message);
                                                    if (error.response.data.errors) {
                                                        Object.keys(error.response.data.errors).forEach(function (item) {
                                                            error.response.data.errors[item].forEach(v => PNotify.alert(v))
                                                        });
                                                    }*/
                    }
                });
            },

            validate() {
                if (this.$refs.form.validate()) {

                    this.reachGoal('step4_click');

                    this.prepareFormData();
/*                    this.preview.show = true;
                    this.$nextTick(function () {
                        $('.preview-window').css('height', $(window).height());
                    });*/

                    this.submit();

                    this.reachGoal('calcFinish');
                } else {
                    this.$nextTick(function () {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.goToFirstError();
                    });
                }
            },

            goToFirstError() {
                this.$vuetify.goTo('.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            },

            goToNew() {
                window.location.replace('/osago/new');
            },

            returnToEdit() {
                this.preview.show = false;
                this.reachGoal('calcDataFalse');
            },

            submit() {
                axios.post('/osago/prolongation' + (this.uuid ? '/' + this.uuid + '/update' : '/new'), this.preparedFormData)
                    .then(response => {
                        if (response.data.uuid) {
                            this.uuid = response.data.uuid;
                            window.history.pushState(null, null, '/osago/prolongation/' + this.uuid);
                        }
                        this.autoSaveOff();

                        this.companiesList = response.data.companiesList;
                        this.companiesList.map((company, index) => this.process(company, index));

                        this.preview.show = false;

                        $('.preloading').css('height', $(window).height());
                        this.preloading = true;

                        let that = this;
                        setTimeout(function () {
                            that.$vuetify.goTo('.preloading', {
                                duration: 500,
                                offset: 0,
                                easing: 'easeInCubic',
                            }).then(() => {
                                $('.preloading')
                                    .css('position', 'fixed')
                                    .css('height', '100%');
                            });
                        }, 100);

                        setTimeout(function () {
                            that.preloading = false;
                        }, 5 * 1000);

                        this.reachGoal('calcDataTrue');

                    }).catch(error => {
                    console.log(error);
                    this.preview.show = false;
                    if (error.response.data.message) {
                        // PNotify.alert('Ошибка. Проверьте правильность введенных данных.');
                        let errorTexts = '';

                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(function (item) {
                                error.response.data.errors[item].forEach(v => errorTexts += ' ' + v)
                            });
                        }
                        PNotify.alert(error.response.data.message + errorTexts);
                    }
                    throw error;
                });
            },

            process(company, index) {
                this.processings++;
                axios.get(company.url).then(response => {
                    this.processings--;
                    if (response.data.payment === undefined || response.data.payment.kbm === undefined) {
                        company.status = 'error';
                    } else {
                        company.payment = response.data.payment;
                        company.status = 'ready';
                    }
                }).catch(error => {
                    this.processings--;
                    console.log(error);
                    company.status = 'error';
                    if (error.response && error.response.data.message) {
                        company.error_text = error.response.data.message;
                        /*PNotify.error(company.name + ":\n" + error.response.data.message);*/
                    }
                });
                Vue.set(this.companiesList, index, company);
            },

            clear() {
                this.$refs.form.reset()
            },
        }
    }
</script>

<style scoped>
    a.policy {
        color: #00ba57;
    }

    .policy-wrapper {
        text-align: left;
        display: table-cell;
        vertical-align: middle;
    }

    .driverControls a {
        color: #000000;
    }

    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 24px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 100px;
        background-color: #00ba57 !important;;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: normal;
        padding: 0 50px;
        line-height: 1.1;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;

        /*        font-size: 46px;
                line-height: 1.55;
                font-weight: 400;*/
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    .preloading {
        position: relative;
        z-index: 999;
        height: 100%;
        width: 100%;
        max-width: 100%;
        overflow: visible;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        background: white;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .preloader-circle {
        background: #00ba57;
        width: 100px;
        height: 100px;
        margin: auto;
        border-radius: 100%;
        -webkit-animation: grow 1s infinite;
    }

    @-webkit-keyframes grow {
        0% {
            -webkit-transform: scale(0.7)
        }

        50% {
            -webkit-transform: scale(0.9)
        }

        100% {
            -webkit-transform: scale(0.7)
        }
    }

    /deep/ input[aria-label="Пол"] {
        padding: 0;
    }

    /deep/ .v-tabs__item {
        justify-content: left;
        text-transform: none;
        font-size: 16px;
        font-weight: 500;
    }

    /deep/ .v-tabs__item--active {
        font-weight: 700;
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/OsagoProlongationForm.vue